/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
import React, { useEffect, useState, useMemo, useCallback } from 'react'
import { useMediaQuery } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Dialog } from '@progress/kendo-react-dialogs'

import DocumentPanelView from '../../views/document-panel/document-panel.view'
import PdfReader from '../../pures/adobePfdReader/PdfReader'
import { ButtonHLPure, DialogSystemGLPure } from '../../pures'
import { b64toBlob } from '../../../validators'
import localStorageService from '../../../services/localStorage.service'
import { DigitalVaultService, DomainService, UserService, LocalStorageService } from '../../../services'
import { AIDocumentAnalysisAction } from '../../actions'

const DocumentPanelAction = (props) => {
  let {
    documentData,
    handleEditDoc,
    handlePrintDoc,
    handleSendEmailDoc,
    handleShareDoc,
    handleDeleteDoc,
    handleVersionDoc,
    handleSignRequest,
    permissions,
    signedInGovo,
    url,
    toggleLoadingRequesting,
    handleFile,
    selectedFileName,
    selectedFile,
    handleDeleteFile,
    handleCloseDialogVersion,
    handleShowDialogVersion,
    showDialogVersion,
    setShowDialogVersion,
    errorFile,
    selectedFileBase64,
    handleDownloadDoc,
    fileExpSelected,
    userCollaborators,
    toggleErrorRequesting,
    fromDelete,
    handleRestoreDocument,
    handleDeletePermanently,
    isEditing,
    onToggleEdit,
    onRequestSave,
    handleReturn,
    isDeletingDocument = false,
    toggleCompletedRequesting,
    showLeftDownload,
    showShareLeft,
    showDeleteLeft,
    showEditLeft,
    isAIModalOpen,
    setIsAIModalOpen
  } = props

  const { t } = useTranslation()

  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false)

  const handleLocalRestoreDocument = useCallback(async () => {
    try {
      toggleLoadingRequesting(true)

      if (handleRestoreDocument) {
        await handleRestoreDocument(documentData.id)
      } else {
        const digitalVaultService = new DigitalVaultService(process.env.REACT_APP_MIFIRMA_API)
        const localStorageService = new LocalStorageService()
        const tokenData = localStorageService.getLocalStorageItem("token")
        const token = tokenData?.idToken

        if (!token) {
          throw new Error('No se encontró token de autenticación')
        }

        if (!isDeletingDocument) {
          await digitalVaultService.startDeleteWorkflow(documentData.id, false, token)
        } else {
          await digitalVaultService.nextDeleteWorkflowStep(documentData.id, token, false)
        }
      }
      toggleCompletedRequesting(4000, true, '/')
      toggleLoadingRequesting(false)
    } catch (error) {
      console.error('Error al restaurar documento:', error)
      toggleLoadingRequesting(false)
      if (toggleErrorRequesting) {
        toggleErrorRequesting('Error al restaurar el documento', 4000, false)
      }
    }
  }, [toggleLoadingRequesting, handleRestoreDocument, documentData, toggleErrorRequesting, isDeletingDocument])


  const handleLocalDeletePermanently = async () => {
    try {
      toggleLoadingRequesting(true)

      const digitalVaultService = new DigitalVaultService(process.env.REACT_APP_MIFIRMA_API)
      const localStorageService = new LocalStorageService()
      const tokenData = localStorageService.getLocalStorageItem("token")
      const token = tokenData?.idToken;

      if (!token) throw new Error('No se encontró token de autenticación')

      if (!isDeletingDocument) {
        await digitalVaultService.startDeleteWorkflow(documentData.id, true, token)
      } else {
        await digitalVaultService.nextDeleteWorkflowStep(documentData.id, token, true)
      }

      toggleCompletedRequesting(4000, true, '/')
    } catch (error) {
      console.error('Error al eliminar documento permanentemente:', error)
    } finally {
      toggleLoadingRequesting(false)
    }
  };


  const handleLocalGoBackToInbox = useCallback(() => {
    const hash = window.location.hash || ''
    const isBinContext = hash.includes('papelera') || hash.includes('bin') || hash.includes('/digital-vault/bin') || fromDelete === true
    if (isBinContext) {
      if (typeof props.goBack === 'function') {
        props.goBack()
      }
      window.location.hash = '/digital-vault/bin'
    } else {
      window.location.hash = '/'
    }
  }, [props.goBack, fromDelete])

  const handleShowDeleteConfirmModal = useCallback(() => {
    setShowDeleteConfirmModal(true)
  }, [])


  const handleCloseDeleteConfirmModal = () => {
    setShowDeleteConfirmModal(false)
  }

  const handleConfirmDeletePermanently = () => {
    setShowDeleteConfirmModal(false)
    handleLocalDeletePermanently()
  }
  const permissionsCheckBox = useMemo(() => [
    {
      name: t('documentPanelActions.alerts'),
      value: false,
      nameBD: 'alerts',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_ALERTS}`,
      checked: false,
    },
    {
      name: t('documentPanelActions.edit'),
      value: false,
      nameBD: 'edit',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_EDIT}`,
      checked: false,
    },
    {
      name: t('documentPanelActions.download'),
      value: false,
      nameBD: 'download',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_DOWNLOAD}`,
      checked: false,
    },
    {
      name: t('documentPanelActions.delete'),
      value: false,
      nameBD: 'delete',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_TRASH}`,
      checked: false,
    },
    {
      name: t('documentPanelActions.version'),
      value: false,
      nameBD: 'version',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_VERSION}`,
      checked: false,
    },
    {
      name: t('documentPanelActions.share'),
      value: false,
      nameBD: 'share',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_SHARE}`,
      checked: false,
    },
    {
      name: t('documentPanelActions.print'),
      value: false,
      nameBD: 'print',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_PRINT}`,
      checked: false,
    },
    {
      name: t('documentPanelActions.signRequest'),
      value: false,
      nameBD: 'signRequest',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_SIGN_REQUEST}`,
      checked: false,
    },
  ], [t])

  const deleteRequestActions = useMemo(() => [
    {
      name: t('digitalVaultBinView.grid.btns.restore'),
      value: false,
      nameBD: 'restore',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_RESTORE}`,
      checked: false,
      handler: handleLocalRestoreDocument
    },
    {
      name: t('digitalVaultBinView.grid.btns.delete'),
      value: false,
      nameBD: 'deletePermanently',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_TRASH}`,
      checked: false,
      handler: handleShowDeleteConfirmModal
    },
    {
      name: t('button.return'),
      value: false,
      nameBD: 'goBack',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_SIGN_REQUEST_BACK}`,
      checked: false,
      handler: handleLocalGoBackToInbox
    }
  ], [t, handleLocalRestoreDocument, handleLocalGoBackToInbox, handleShowDeleteConfirmModal])

  const [urlDocs, setUrlDocs] = useState('')
  const [showDialogSendEmail, setShowDialogSendEmail] = useState(false)
  const [email, setEmail] = useState('')
  const [messageEmail, setMessageEmail] = useState('')
  const [errorInput, setErrorInput] = useState(false)
  const [errorInputText, setErrorInputText] = useState('')
  const [errorInputArea, setErrorInputArea] = useState(false)
  const [errorTextArea, setErrorTextArea] = useState('')
  const [blobUrl, setBlobUrl] = useState('')
  const [showDialogShare, setShowDialogShare] = useState(false)
  const [usersSend, setUsersSend] = useState('')
  const [messageShare, setMessageShare] = useState('')
  const [errorInputShare, setErrorInputShare] = useState(false)
  const [errorInputTextShare, setErrorInputTextShare] = useState('')
  const [usersSendGrid, setUsersSendGrid] = useState([])
  const [userSendGridSelected, setUserSendGridSelected] = useState({})
  const [usersChip, setUsersChip] = useState([])
  const [showDeleteDocument, setShowDeleteDocument] = useState(false)
  const [showDialogPrint, setShowDialogPrint] = useState(false)
  const [userSearch, setUserSearch] = useState('')
  const [usersGrid, setUsersGrid] = useState([])
  const [permisos, setPermisos] = useState([])
  const [addCollaboratorErrors, setAddCollaboratorErrors] = useState({ emailInvalid: false, emailExists: false, domainError: '', firstName: false, lastName: false })
  const [newCollaborator, setNewCollaborator] = useState({ email: '', firstName: '', lastName: '' })
  const [showDialogAddCollaborator, setShowDialogAddCollaborator] = useState(false)
  const [activeShareTab, setActiveShareTab] = useState(process.env.REACT_APP_USER_TAB_COLLABORATORS)
  const userService = new UserService(process.env.REACT_APP_MIFIRMA_API)
  const [effectivePermissions, setEffectivePermissions] = useState({})

  const [collaboratorPermissions, setCollaboratorPermissions] = useState([])
  const [invitedPermissions, setInvitedPermissions] = useState([])
  const [collaboratorMessage, setCollaboratorMessage] = useState('')
  const [invitedMessage, setInvitedMessage] = useState('')
  const [selectedCollaborators, setSelectedCollaborators] = useState([])
  const [selectedInvited, setSelectedInvited] = useState([])

  // Colaborador
  const [collaboratorsAll, setCollaboratorsAll] = useState([])
  const [emailDomains, setEmailDomains] = useState([])
  const [invitedAll, setInvitedAll] = useState([])

  // Paginación
  const [collaboratorOffset, setCollaboratorOffset] = useState(0)
  const [invitedOffset, setInvitedOffset] = useState(0)
  const [collaboratorLimit] = useState(50)
  const [invitedLimit] = useState(50)
  const [collaboratorHasMore, setCollaboratorHasMore] = useState(true)
  const [invitedHasMore, setInvitedHasMore] = useState(true)
  const [isLoadingUsers, setIsLoadingUsers] = useState(false)

  // Invitado
  const [showDialogAddInvited, setShowDialogAddInvited] = useState(false)
  const [newInvited, setNewInvited] = useState({ email: '', firstName: '', lastName: '' })
  const [addInvitedErrors, setAddInvitedErrors] = useState({ emailInvalid: false, emailExists: false, firstName: false, lastName: false })

  // Analizar con IA
  const [showDialogAnalyzeIA, setShowDialogAnalyzeIA] = useState(false)

  // Tipos de usuario (desde variables de entorno)
  const USER_TYPE_ADMINISTRADOR = Number(process.env.REACT_APP_USER_TYPE_ADMINISTRADOR)
  const USER_TYPE_COLABORADOR = Number(process.env.REACT_APP_USER_TYPE_COLABORADOR)
  const USER_TYPE_INVITADO = Number(process.env.REACT_APP_USER_TYPE_INVITADO)


  const defaultDocsUserRole = Number(process.env.REACT_APP_GRC_DOCS_ROLE_ID_USER) || null
  const defaultDocsSubscriberRole = Number(process.env.REACT_APP_GRC_DOCS_ROLE_ID_SUSCRIBER) || null
  const defaultCompanyN1Role = Number(process.env.REACT_APP_COMPANY_ROLE_ID_N1) || null

  useEffect(() => {
    const currentPath = window.location.hash || window.location.pathname
    const isInBin = currentPath.includes('papelera') ||
      currentPath.includes('bin') ||
      currentPath.includes('/digital-vault/bin') ||
      documentData?.status === process.env.REACT_APP_DOCUMENT_STATUS_ELIMINADO

    const isFromDeleteRequest = fromDelete === true

    let currentActions
    if (isInBin || isFromDeleteRequest) {
      currentActions = deleteRequestActions
    } else {
      currentActions = permissionsCheckBox
    }

    setPermisos(currentActions)

    setCollaboratorPermissions(currentActions.map(p => ({ ...p })))
    setInvitedPermissions([{
      name: t('documentPanelActions.download'),
      value: false,
      nameBD: 'download',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_DOWNLOAD}`,
      checked: false,
    }])
  }, [fromDelete, deleteRequestActions, permissionsCheckBox, documentData, t])

  const sharedPermissions = useMemo(() => {
    if (documentData?.sharedPermissions || documentData?.permissions) {
      const perms = documentData.sharedPermissions || documentData.permissions
      return perms
    }

    return null
  }, [documentData])

  const permissionsObject = useMemo(() => {
    const currentPath = window.location.hash || window.location.pathname
    const isInBin = currentPath.includes('papelera') ||
      currentPath.includes('bin') ||
      currentPath.includes('/digital-vault/bin') ||
      documentData?.status === process.env.REACT_APP_DOCUMENT_STATUS_ELIMINADO

    const isFromDeleteRequest = fromDelete === true

    if (sharedPermissions) {
      const result = {
        alerts: sharedPermissions.alerts === true,
        edit: sharedPermissions.edit === true,
        print: sharedPermissions.print === true,
        download: sharedPermissions.download === true,
        send: sharedPermissions.send === true,
        share: sharedPermissions.share === true,
        delete: sharedPermissions.delete === true,
        version: sharedPermissions.version === true,
        play: sharedPermissions.play === true
      }
      return result
    }

    if (isInBin || isFromDeleteRequest) {
      return {
        alerts: false,
        edit: false,
        print: false,
        download: false,
        send: false,
        share: false,
        delete: false,
        version: false,
        play: false
      }
    } else {
      const result = {
        alerts: permissions?.alerts === true,
        edit: permissions?.edit === true,
        print: permissions?.print === true,
        download: permissions?.download === true,
        send: permissions?.send === true,
        share: permissions?.share === true,
        delete: permissions?.delete === true,
        version: permissions?.version === true,
        play: permissions?.play === true
      }
      return result
    }
  }, [fromDelete, permissions, documentData, sharedPermissions])

  const mobileResolution = useMediaQuery('(max-width:560px)')
  const is2000 = useMediaQuery('(max-width:2000px)')
  const is1500 = useMediaQuery('(max-width:1500px)')
  const is1366 = useMediaQuery('(max-width:1366px)')
  let heightContainer = mobileResolution ? 450 : 800
  let widthContainer = mobileResolution ? 550 : 1000
  let heightBody = mobileResolution ? 230 : 400

  if (is2000) {
    heightBody = 550
  }

  if (is1500) {
    heightBody = 500
  }

  if (is1366) {
    heightContainer = 700
    heightBody = 420
  }

  const pdf = useMemo(
    () => (
      <PdfReader
        className='pdfReader'
        file={selectedFileBase64}
        isFile
        src={`data:application/pdf;base64,${selectedFileBase64}`}
      ></PdfReader>
    ),
    [selectedFileBase64]
  )

  useEffect(() => {
    if (selectedFileBase64) {
      const blob = b64toBlob(selectedFileBase64, 'application/pdf')
      setBlobUrl(blob)
    }
  }, [selectedFileBase64])

  useEffect(() => {
    if (!url) return
    setUrlDocs(url)
  }, [url])

  const loadUsers = useCallback(async (isCollaborators, offset, limit, append = false) => {
    setIsLoadingUsers(true)
    try {
      const localStorageService = new LocalStorageService();
      const tokenData = localStorageService.getLocalStorageItem('token')
      const token = tokenData?.idToken

      if (!token) return

      // Colaboradores: sin offset/limit (null), Invitados: con offset/limit
      const data = await userService.getUsersCollaboratorsOrInvites(
        token,
        isCollaborators,
        !isCollaborators,
        isCollaborators ? null : offset,
        isCollaborators ? null : limit,
        userSearch
      )

      let page = []
      if (isCollaborators) {
        page = data?.usersCollaborator?.active || data?.active || data || []
      } else {
        page = data?.usersInvite?.active || data?.active || data || []
      }

      const actives = page.filter((u) => u?.status === true || u?.active === true || u?.enabled === true)
      const mapped = actives.map((u) => ({
        id: u.id ?? u.userId ?? null,
        name:
          u.name ||
          u.fullName ||
          [u.firstName, u.firstLastName, u.secondLastName].filter(Boolean).join(' ') ||
          (u.email ? String(u.email).split('@')[0] : '-') ||
          '-',
        email: (u.email || '').toLowerCase(),
        checked: false,
        userTypeId: u?.userTypeId ?? u?.id ?? null,
        source: isCollaborators ? 'collaborator' : 'invited'
      }))

      if (isCollaborators) {
        // Colaboradores: siempre reemplazar (no append), sin paginación
        setCollaboratorsAll(mapped)
        setCollaboratorHasMore(false)
      } else {
        // Invitados: sí usar paginación
        setInvitedAll(prev => append ? [...prev, ...mapped] : mapped)
        setInvitedHasMore(mapped.length >= limit)
      }
    } catch (error) {
      console.log('Error loading users:', error)
    } finally {
      setIsLoadingUsers(false)
    }
  }, [userService, userSearch, t, toggleErrorRequesting])

  useEffect(() => {
    try {
      const localStorageService = new LocalStorageService();
      const tokenData = localStorageService.getLocalStorageItem('token')
      const token = tokenData?.idToken
      if (!token) return
      const domainService = new DomainService(process.env.REACT_APP_MIFIRMA_API)
      domainService.getDomains(token).then((domains) => setEmailDomains(domains || [])).catch(() => { })
    } catch (_) { /* noop */ }
  }, [])

  useEffect(() => {
    const base = activeShareTab === process.env.REACT_APP_USER_TAB_INVITED ? invitedAll : collaboratorsAll
    const term = (userSearch || '').toLowerCase()
    const filtered = term
      ? base.filter(
        (item) =>
          (item.name || '').toLowerCase().includes(term) ||
          (item.email || '').toLowerCase().includes(term)
      )
      : base
    setUsersGrid(filtered)

    if (activeShareTab === process.env.REACT_APP_USER_TAB_INVITED) {
      setPermisos(invitedPermissions)
      setMessageShare(invitedMessage)
    } else {
      setPermisos(collaboratorPermissions)
      setMessageShare(collaboratorMessage)
    }
  }, [activeShareTab, collaboratorsAll, invitedAll, userSearch, collaboratorPermissions, invitedPermissions, collaboratorMessage, invitedMessage])

  const handleLoadMoreUsers = useCallback(() => {
    const isInvitedTab = activeShareTab === process.env.REACT_APP_USER_TAB_INVITED
    if (isLoadingUsers) return

    // Solo cargar más si estamos en el tab de invitados y hay más datos
    if (isInvitedTab && invitedHasMore) {
      const newOffset = invitedOffset + invitedLimit
      setInvitedOffset(newOffset)
      loadUsers(false, newOffset, invitedLimit, true)
    }
  }, [activeShareTab, isLoadingUsers, invitedHasMore, invitedOffset, invitedLimit, loadUsers])

  const handleShowDialog = () => {
    setShowDialogSendEmail(true)
  }

  const handleCloseDialog = () => {
    setShowDialogSendEmail(false)
  }

  const handleChangeEmail = (e) => {
    setErrorInputText('')
    setErrorInput(false)
    let value = e.target.value
    value = value ? value : ''

    setEmail(value)
  }

  const handleChangeMessageEmail = (e) => {
    setErrorTextArea('')
    setErrorInputArea(false)
    let value = e.target.value
    value = value ? value : ''

    setMessageEmail(value)
  }

  const handleSubmitDialog = () => {
    if (!email || email === '' || !messageEmail || messageEmail === '') {
      let messageError =
        !email || email === ''
          ? t('document.panel.actions.share.validation.requiredEmail')
          : t('document.panel.actions.share.validation.requiredMessage')
      if (!email || email === '') {
        messageError = t('document.panel.actions.share.validation.requiredEmail')
        setErrorInputText(messageError)
        setErrorInput(true)
      }

      if (!messageEmail || messageEmail === '') {
        messageError = t('document.panel.actions.share.validation.requiredMessage')
        setErrorTextArea(messageError)
        setErrorInputArea(true)
      }
      return
    }

    setShowDialogSendEmail(false)
    toggleLoadingRequesting(true)
    let emails = email
    let documentId = documentData.id
    let comments = messageEmail
    let fileIdExp = null
    if (documentData.infoType === 'Expediente') {
      fileIdExp = fileExpSelected.id
    }

    handleSendEmailDoc(
      emails,
      documentId,
      comments,
      setEmail,
      setMessageEmail,
      fileIdExp
    )
  }

  const handleChangeTab = (tab) => {
    if (activeShareTab === process.env.REACT_APP_USER_TAB_INVITED) {
      setInvitedMessage(messageShare)
      setInvitedPermissions([...permisos])
    } else {
      setCollaboratorMessage(messageShare)
      setCollaboratorPermissions([...permisos])
    }

    setActiveShareTab(tab)
    setUserSearch('')

    // Cargar usuarios si no se han cargado aún
    if (tab === process.env.REACT_APP_USER_TAB_INVITED) {
      if (invitedAll.length === 0) {
        loadUsers(false, 0, invitedLimit, false)
      }
    } else {
      if (collaboratorsAll.length === 0) {
        loadUsers(true, null, null, false) // Colaboradores sin offset/limit
      }
    }
  }


  const handleOpenCloseDialogShare = async () => {
    setErrorInputTextShare('')
    setErrorInputShare(false)

    if (showDialogShare) {
      setUsersSendGrid([])
      setSelectedCollaborators([])
      setSelectedInvited([])
      setMessageShare('')
      setCollaboratorMessage('')
      setInvitedMessage('')
      setUserSearch('')
      setActiveShareTab(process.env.REACT_APP_USER_TAB_COLLABORATORS)

      setCollaboratorsAll(prev => prev.map(u => ({ ...u, checked: false })))
      setInvitedAll(prev => prev.map(u => ({ ...u, checked: false })))

      const defaultPerms = permissionsCheckBox.map(p => ({ ...p, checked: false }))
      setCollaboratorPermissions(defaultPerms)
      setInvitedPermissions([{
        name: t('documentPanelActions.download'),
        value: false,
        nameBD: 'download',
        icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_DOWNLOAD}`,
        checked: false,
      }])
      setShowDialogShare(false)
    } else {
      // Abriendo el diálogo - cargar usuarios si no están en caché
      const needsToLoadCollaborators = collaboratorsAll.length === 0
      const needsToLoadInvited = invitedAll.length === 0

      if (needsToLoadCollaborators || needsToLoadInvited) {
        toggleLoadingRequesting(true)

        try {
          const promises = []

          if (needsToLoadCollaborators) {
            promises.push(loadUsers(true, null, null, false))
          }

          if (needsToLoadInvited) {
            setInvitedOffset(0)
            promises.push(loadUsers(false, 0, invitedLimit, false))
          }

          await Promise.all(promises)
        } catch (error) {
          throw new Error('Error loading users:', error)
        } finally {
          toggleLoadingRequesting(false)
        }
      }

      setShowDialogShare(true)
    }
  }


  const handleSubmitDialogShare = (e) => {
    const allSelectedUsers = [...selectedCollaborators, ...selectedInvited]

    if (!allSelectedUsers || allSelectedUsers.length === 0) {
      let messageError = t('document.panel.actions.share.validation.requiredUser')
      toggleLoadingRequesting(false)
      toggleErrorRequesting(messageError, 4000, false)
      return
    }

    const documentId = documentData.id

    const collaboratorUsers = selectedCollaborators.map((user) => {
      const existingUser = collaboratorsAll.find(
        (u) => (u.email || '').toLowerCase() === (user.email || '').toLowerCase()
      )

      const isExistingUser = existingUser && existingUser.id && existingUser.id !== 'null'

      const permissions = {}
      collaboratorPermissions.forEach(p => {
        let backendName = p.nameBD
        if (p.nameBD === 'edit') {
          backendName = 'editMetadata'
        } else if (p.nameBD === 'send') {
          backendName = 'sendMail'
        }
        permissions[backendName] = !!p.checked
      })

      const fullPermissions = {
        play: permissions.play || false,
        print: permissions.print || false,
        share: permissions.share || false,
        alerts: permissions.alerts || false,
        delete: permissions.delete || false,
        version: permissions.version || false,
        download: permissions.download || false,
        sendMail: permissions.sendMail || false,
        editMetadata: permissions.editMetadata || false
      }

      return {
        id: isExistingUser ? existingUser.id : null,
        email: (user.email || '').toLowerCase(),
        userTypeId: USER_TYPE_COLABORADOR,
        permissions: fullPermissions
      }
    })

    const invitedUsers = selectedInvited.map((user) => {
      const downloadPerm = (invitedPermissions || []).find(p => p.nameBD === 'download')

      const existingInvited = invitedAll.find(
        (u) => (u.email || '').toLowerCase() === (user.email || '').toLowerCase()
      )

      const isExistingInvited = existingInvited && existingInvited.id && existingInvited.id !== 'null'

      return {
        id: isExistingInvited ? existingInvited.id : null,
        email: (user.email || '').toLowerCase(),
        userTypeId: USER_TYPE_INVITADO,
        permissions: {
          play: false,
          print: false,
          share: false,
          alerts: false,
          delete: false,
          version: false,
          download: !!downloadPerm?.checked,
          sendMail: false,
          editMetadata: false
        }
      }
    })

    const hasBothTypes = selectedCollaborators.length > 0 && selectedInvited.length > 0
    const hasDifferentMessages = collaboratorMessage?.trim() !== invitedMessage?.trim()

    if (hasBothTypes && hasDifferentMessages) {
      if (collaboratorUsers.length > 0) {
        handleShareDoc(
          {
            documentId,
            users: collaboratorUsers,
            message: collaboratorMessage?.trim() || '',
          },
          setUsersSend,
          setUsersSendGrid,
          setUsersChip,
          () => { },
          setMessageShare
        )
      }

      if (invitedUsers.length > 0) {
        handleShareDoc(
          {
            documentId,
            users: invitedUsers,
            message: invitedMessage?.trim() || '',
          },
          setUsersSend,
          setUsersSendGrid,
          setUsersChip,
          setShowDialogShare,
          setMessageShare
        )
      }
    } else {
      const allUsers = [...collaboratorUsers, ...invitedUsers]
      const messageToSend = selectedCollaborators.length > 0
        ? collaboratorMessage
        : invitedMessage

      handleShareDoc(
        {
          documentId,
          users: allUsers,
          message: messageToSend?.trim() || '',
        },
        setUsersSend,
        setUsersSendGrid,
        setUsersChip,
        setShowDialogShare,
        setMessageShare
      )
    }

    setUsersSendGrid([])
    setSelectedCollaborators([])
    setSelectedInvited([])
    setMessageShare('')
    setCollaboratorMessage('')
    setInvitedMessage('')
    setUserSearch('')
    setActiveShareTab(process.env.REACT_APP_USER_TAB_COLLABORATORS)

    setCollaboratorsAll(prev => prev.map(u => ({ ...u, checked: false })))
    setInvitedAll(prev => prev.map(u => ({ ...u, checked: false })))

    const defaultPerms = permissionsCheckBox.map(p => ({ ...p, checked: false }))
    setCollaboratorPermissions(defaultPerms)
    setInvitedPermissions([{
      name: t('documentPanelActions.download'),
      value: false,
      nameBD: 'download',
      icon: `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_ICONS_BOVEDA_DIGITAL_DOWNLOAD}`,
      checked: false,
    }])
  }

  const handleShowDialogDelete = () => {
    setShowDeleteDocument(true)
  }

  const handleCloseDialogDelete = () => {
    setShowDeleteDocument(false)
  }

  const handleDeleteDocument = () => {
    setShowDeleteDocument(false)
    handleDeleteDoc()
  }

  const handleShowDialogPrint = (e, isDocument) => {
    handlePrintDoc(e, documentData, isDocument)
  }

  const handleCloseDialogPrint = () => {
    setShowDialogPrint(false)
  }

  const filterChangeUsers = (e) => {
    setUserSearch(e.target.value)
  }

  const onChangeCheckShare = (e, userSelected) => {
    const checked = e.target.checked
    const isInvitedTab = activeShareTab === process.env.REACT_APP_USER_TAB_INVITED
    const sourceArray = isInvitedTab ? invitedAll : collaboratorsAll

    const foundUser = sourceArray.find(u => u.email === userSelected.email)

    if (isInvitedTab) {
      if (checked) {
        setSelectedInvited(prev => [...prev, {
          ...userSelected,
          userTypeId: foundUser?.userTypeId ?? USER_TYPE_INVITADO
        }])
      } else {
        setSelectedInvited(prev => prev.filter(u => u.email !== userSelected.email))
      }
    } else {
      if (checked) {
        setSelectedCollaborators(prev => [...prev, {
          ...userSelected,
          userTypeId: foundUser?.userTypeId ?? USER_TYPE_COLABORADOR
        }])
      } else {
        setSelectedCollaborators(prev => prev.filter(u => u.email !== userSelected.email))
      }
    }

    let copyUsersSend = [...usersSendGrid]
    let newUsersSend = []

    if (checked) {
      copyUsersSend.push({
        ...userSelected,
        userTypeId: foundUser?.userTypeId ?? (isInvitedTab ? USER_TYPE_INVITADO : USER_TYPE_COLABORADOR)
      })
      newUsersSend = [...copyUsersSend]
    } else {
      newUsersSend = copyUsersSend.filter(
        (user) => user.email !== userSelected.email
      )
    }

    setUsersSendGrid(newUsersSend)

    const updated = sourceArray.map(u =>
      u.email === userSelected.email ? { ...u, checked } : u
    )

    if (isInvitedTab) {
      setInvitedAll(updated)
    } else {
      setCollaboratorsAll(updated)
    }
  }

  const onClickBtnActions = (e, action) => {
    if (isDeletingDocument) {
      const isDelete = action.name === t('digitalVaultBinView.grid.btns.delete')
      if (isDelete && !fromDelete) return
      if (isDelete && fromDelete) {
        setShowDeleteConfirmModal(true)
        return
      }
    }
    if (action.handler) {
      action.handler()
      return
    }

    let newPermisos = permisos.map((permiso) => {
      if (permiso.name === action.name) {
        permiso.value = !permiso.value
        permiso.checked = !permiso.checked
      }

      return permiso
    })

    setPermisos(newPermisos)
  }

  const onTogglePermission = (e, action) => {
    const checked = e?.target?.checked ?? !action.checked

    if (activeShareTab === process.env.REACT_APP_USER_TAB_INVITED) {
      const newInvitedPerms = invitedPermissions.map((permiso) => {
        if (permiso.name === action.name) {
          return { ...permiso, value: checked, checked }
        }
        return permiso
      })
      setInvitedPermissions(newInvitedPerms)
      setPermisos(newInvitedPerms)
    } else {
      const newCollabPerms = collaboratorPermissions.map((permiso) => {
        if (permiso.name === action.name) {
          return { ...permiso, value: checked, checked }
        }
        return permiso
      })
      setCollaboratorPermissions(newCollabPerms)
      setPermisos(newCollabPerms)
    }
  }

  const handleChangeMessageShare = (e) => {
    let value = e.target.value
    setMessageShare(value)

    if (activeShareTab === process.env.REACT_APP_USER_TAB_INVITED) {
      setInvitedMessage(value)
    } else {
      setCollaboratorMessage(value)
    }
  }

  const handleReturnToBoveda = () => {
    try {
      if (props.goBack && typeof props.goBack === 'function') {
        props.goBack()
        return
      } else { window.history.back() }

      if (handleReturn && typeof handleReturn === 'function') {
        handleReturn()
        return
      }

      const currentPath = window.location.hash || window.location.pathname
      const isInBin =
        currentPath.includes('papelera') ||
        currentPath.includes('bin') ||
        currentPath.includes('/digital-vault/bin')

      window.location.hash = isInBin ? '/digital-vault/bin' : '/digital-vault'
    } catch (error) {
      window.location.hash = '/digital-vault'
    }
  }

  const handleAnalyzeWithIA = () => {
    setShowDialogAnalyzeIA(true)
    if (setIsAIModalOpen) {
      setIsAIModalOpen(true)
    }
  }

  const handleCloseAnalyzeIA = () => {
    setShowDialogAnalyzeIA(false)
    if (setIsAIModalOpen) {
      setIsAIModalOpen(false)
    }
  }

  const handlers = {
    handleDeleteDoc,
    handleDeleteFile,
    handleDownloadDoc,
    handleEditDoc,
    handleFile,
    handlePrintDoc,
    handleSendEmailDoc,
    handleShareDoc,
    handleSignRequest,
    handleVersionDoc,
    handleChangeMessageShare,
    handleCloseDialog,
    handleChangeEmail,
    handleChangeMessageEmail,
    handleCloseDialogDelete,
    handleCloseDialogPrint,
    handleCloseDialogVersion,
    handleDeleteDocument,
    handleOpenCloseDialogShare,
    handleShowDialog,
    handleShowDialogDelete,
    handleShowDialogPrint,
    handleShowDialogVersion,
    handleSubmitDialog,
    handleSubmitDialogShare,
    filterChangeUsers,
    onChangeCheckShare,
    onClickBtnActions,
    handleReturn: handleReturnToBoveda,
    onTogglePermission,
    handleChangeTab,
    activeShareTab,
    setActiveShareTab,
    selectedCollaboratorsCount: selectedCollaborators.length,
    selectedInvitedCount: selectedInvited.length,
    handleOpenAddCollaborator: () => setShowDialogAddCollaborator(true),
    handleCloseAddCollaborator: () => setShowDialogAddCollaborator(false),
    handleAddCollaboratorChange: (event, field) => {
      const value = event?.target?.value ?? ''
      setNewCollaborator((prev) => ({ ...prev, [field]: value }))
      setAddCollaboratorErrors((prev) => ({ ...prev, emailInvalid: false, emailExists: false, domainError: '', [field]: false }))
    },
    handleAddCollaboratorSubmit: (e) => {
      if (e && typeof e.preventDefault === process.env.REACT_APP_KEYWORD_FUNCTION) e.preventDefault()
      const email = (newCollaborator.email || '').trim().toLowerCase()
      const firstName = (newCollaborator.firstName || '').trim()
      const lastName = (newCollaborator.lastName || '').trim()

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      let hasError = false
      const nextErrors = { emailInvalid: false, emailExists: false, domainError: '', firstName: false, lastName: false }

      if (!emailRegex.test(email)) { nextErrors.emailInvalid = true; hasError = true }
      if (firstName.length < 2) { nextErrors.firstName = true; hasError = true }
      if (lastName.length < 2) { nextErrors.lastName = true; hasError = true }

      const alreadyExists = ([...collaboratorsAll, ...invitedAll] || []).some(u => (u.email || '').toLowerCase() === email)
      if (alreadyExists) { nextErrors.emailExists = true; hasError = true }

      const domainPart = email.includes('@') ? email.split('@')[1] : ''
      const isAllowedDomain = emailDomains?.some?.(d => d?.name?.toLowerCase?.() === domainPart)
      if (!isAllowedDomain) {
        nextErrors.domainError = t('signatureRequest.pure.errorDomain') || 'Este correo no pertenece a un dominio permitido para colaboradores'
        hasError = true
      }

      setAddCollaboratorErrors(nextErrors)
      if (hasError) return

      const newUser = {
        id: null,
        name: `${firstName} ${lastName}`.trim(),
        email,
        checked: false,
        userTypeId: USER_TYPE_COLABORADOR,
      }
      setCollaboratorsAll((prev) => [newUser, ...prev])
      setShowDialogAddCollaborator(false)
      setNewCollaborator({ email: '', firstName: '', lastName: '' })
    },

    handleAddInvitedSubmit: (e) => {
      if (e && typeof e.preventDefault === process.env.REACT_APP_KEYWORD_FUNCTION) e.preventDefault()
      const email = (newInvited.email || '').trim().toLowerCase()
      const firstName = (newInvited.firstName || '').trim()
      const lastName = (newInvited.lastName || '').trim()
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      let hasError = false
      const nextErrors = { emailInvalid: false, emailExists: false, firstName: false, lastName: false }

      if (!emailRegex.test(email)) { nextErrors.emailInvalid = true; hasError = true }
      if (firstName.length < 2) { nextErrors.firstName = true; hasError = true }
      if (lastName.length < 2) { nextErrors.lastName = true; hasError = true }

      const alreadyExists = invitedAll.some(u => (u.email || '').toLowerCase() === email)
      if (alreadyExists) { nextErrors.emailExists = true; hasError = true }

      setAddInvitedErrors(nextErrors)
      if (hasError) return

      const newUser = {
        id: null,
        name: `${firstName} ${lastName}`.trim(),
        email,
        checked: false,
        userTypeId: USER_TYPE_INVITADO,
        source: 'invited'
      }

      setInvitedAll((prev) => [newUser, ...prev])
      setShowDialogAddInvited(false)
      setNewInvited({ email: '', firstName: '', lastName: '' })
    },
    handleOpenAddInvited: () => setShowDialogAddInvited(true),
    handleCloseAddInvited: () => setShowDialogAddInvited(false),
    handleAddInvitedChange: (event, field) => {
      const value = event?.target?.value ?? ''
      setNewInvited((prev) => ({ ...prev, [field]: value }))
      setAddInvitedErrors((prev) => ({ ...prev, emailInvalid: false, emailExists: false, [field]: false }))
    },
    handleLoadMoreUsers,
    handleAnalyzeWithIA,
    handleCloseAnalyzeIA
  }

  useEffect(() => {
    if (documentData?.permissions) {
      setEffectivePermissions(documentData.permissions)
    } else if (permissions) {
      setEffectivePermissions(permissions)
    }
  }, [documentData, permissions])


  const handleBack = () => {
    const currentPath = window.location.hash || window.location.pathname
    const isInBin = currentPath.includes('papelera') || currentPath.includes('bin') || currentPath.includes('/digital-vault/bin')

    if (isInBin) {
      window.location.hash = '/digital-vault/home'
    } else {
      window.location.hash = '/digital-vault/bin'
    }
  }

  const showEditLeftResolved = useMemo(() => {
    const isExpediente = documentData?.infoType === 'Expediente' || documentData?.infoType === process.env.REACT_APP_DIGITAL_VAULT_EXPEDIENTE
    if (isExpediente) return true
    return false
  }, [documentData, showEditLeft])

  if (isDeletingDocument && !fromDelete) {
    return (
      <DialogSystemGLPure
        showInfoRequesting={true}
        infoTitle={t('digitalVaultBinView.deletingFlow.modal.title')}
        infoMessage={t('digitalVaultBinView.deletingFlow.modal.message')}
        labelInfoBtn={t('digitalVaultBinView.return.modal')}
        handleInfoClose={handleBack}
      />
    )
  }


  return (
    <>
      <DocumentPanelView
        {...props}
        blobUrl={blobUrl}
        documentData={documentData}
        email={email}
        errorFile={errorFile}
        errorInput={errorInput}
        errorInputArea={errorInputArea}
        errorInputText={errorInputText}
        errorTextArea={errorTextArea}
        fileExpSelected={fileExpSelected}
        filterChangeUsers={filterChangeUsers}
        handlers={handlers}
        heightBody={heightBody}
        heightContainer={heightContainer}
        messageEmail={messageEmail}
        messageShare={messageShare}
        onChangeCheckShare={onChangeCheckShare}
        onClickBtnActions={onClickBtnActions}
        pdf={pdf}
        permisos={permisos}
        permissions={permissionsObject}
        selectedFile={selectedFile}
        selectedFileBase64={selectedFileBase64}
        selectedFileName={selectedFileName}
        setShowDialogVersion={setShowDialogVersion}
        showDeleteDocument={showDeleteDocument}
        showDialogPrint={showDialogPrint}
        showDialogSendEmail={showDialogSendEmail}
        showDialogShare={showDialogShare}
        showDialogVersion={showDialogVersion}
        signedInGovo={signedInGovo}
        userSearch={userSearch}
        usersChip={usersSendGrid}
        userSendGridSelected={userSendGridSelected}
        usersGrid={usersGrid}
        widthContainer={widthContainer}
        showLeftDownload={!!showLeftDownload}
        showShareLeft={!!showShareLeft}
        showDeleteLeft={!!showDeleteLeft}
        showEditLeft={showEditLeftResolved}
        showDialogAddCollaborator={showDialogAddCollaborator}
        newCollaborator={newCollaborator}
        addCollaboratorErrors={addCollaboratorErrors}
        showDeleteConfirmModal={showDeleteConfirmModal}
        handleShowDeleteConfirmModal={handleShowDeleteConfirmModal}
        handleCloseDeleteConfirmModal={handleCloseDeleteConfirmModal}
        handleConfirmDeletePermanently={handleConfirmDeletePermanently}
        showDialogAddInvited={showDialogAddInvited}
        newInvited={newInvited}
        addInvitedErrors={addInvitedErrors}
        showDialogAnalyzeIA={showDialogAnalyzeIA}
        isLoadingUsers={isLoadingUsers}
        hasMoreUsers={activeShareTab === process.env.REACT_APP_USER_TAB_INVITED ? invitedHasMore : collaboratorHasMore}
      />

      {showDeleteConfirmModal && (
        <DialogSystemGLPure
          showConfirm={true}
          confirmTitle={isDeletingDocument ? t('dialogSystemGLPure.confirmPermanentDelete.title') : t('dialogSystemGLPure.confirmDeleteFlow.title')}
          confirmMessage={isDeletingDocument ? t('dialogSystemGLPure.confirmPermanentDelete.message') : t('dialogSystemGLPure.confirmDeleteFlow.message')}
          labelCancelConfirmation={t('button.cancel')}
          labelSubmitConfirmation={isDeletingDocument ? t('button.delete') : t('dialogSystemGLPure.confirmDeleteFlow.submit')}
          handleConfirmDeleteFlowClose={handleCloseDeleteConfirmModal}
          handleConfirmDeleteFlowSubmit={handleConfirmDeletePermanently}
        />
      )}

      {showDialogAnalyzeIA && (
        <AIDocumentAnalysisAction
          showDialog={showDialogAnalyzeIA}
          documentData={documentData}
          documentUrl={urlDocs}
          selectedFileBase64={selectedFileBase64}
          onClose={handleCloseAnalyzeIA}
        />
      )}
    </>
  )
}

export default DocumentPanelAction